import { Table } from '@mantine/core';
import clsx from 'clsx';
import { ReactNode } from 'react';

type TableDataCellProps = {
    bold?: boolean
    indent?: boolean
    summary?: boolean
    recommended?: boolean
    children?: ReactNode
}

export const TableDataCell = ({ bold, indent, summary, recommended, children }: TableDataCellProps) => {
    return (
        <Table.Td className={clsx('border-border-ultra-light', {
            'border-r': !children,
            'text-lg': !(bold || summary),
            'text-lg-bold': bold || summary,
            'pl-2': indent || summary,
            'bg-chart-category6/25': summary && recommended,
            'bg-chart-category7/25': summary && !recommended
        })}>
            {children}
        </Table.Td>
    );
};

